import * as types from './types';

export const addUser = (dispatch, user) => {
  dispatch({ type: types.USER_ADD, user });
};

export const removeUser = (dispatch) => {
  dispatch({ type: types.USER_REMOVE });
};
